export default {
  user: null,
  error: false
};
